// client/api/services/adminCommercialService.ts
// T-15 — admin CRUD for the currency/country matrix. Each country maps to a
// serving currency and an enabled flag; a disabled country is switched off in
// the captive portal (and any other market-gated flow).
import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export interface CurrencyCountry {
  _id?: string;
  country_code: string;
  currency: string;
  enabled: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CurrencyCountryResponse {
  success?: boolean;
  message?: string;
  count?: number;
  defaultCurrency?: string;
  data?: CurrencyCountry | CurrencyCountry[];
}

export const getCurrencyCountries = async (): Promise<{
  rows: CurrencyCountry[];
  defaultCurrency: string;
}> => {
  const res = await apiClient.get<CurrencyCountryResponse>(
    ENDPOINTS.ADMIN.COMMERCIAL_CURRENCIES
  );
  const d = res.data?.data;
  return {
    rows: Array.isArray(d) ? d : [],
    defaultCurrency: res.data?.defaultCurrency || "USD",
  };
};

export const upsertCurrencyCountry = async (payload: {
  country_code: string;
  currency: string;
  enabled?: boolean;
}): Promise<CurrencyCountry | null> => {
  const res = await apiClient.post<CurrencyCountryResponse>(
    ENDPOINTS.ADMIN.COMMERCIAL_CURRENCIES,
    payload
  );
  const d = res.data?.data;
  return d && !Array.isArray(d) ? d : null;
};

export const deleteCurrencyCountry = async (id: string): Promise<boolean> => {
  const res = await apiClient.delete<CurrencyCountryResponse>(
    ENDPOINTS.ADMIN.COMMERCIAL_CURRENCY(id)
  );
  return Boolean(res.data?.success);
};
